export default __webpack_public_path__ + "static/media/all.f12da85d.svg";